import sanitizeHtml from 'sanitize-html';

const clean = (dirty) => sanitizeHtml(dirty, {
    allowedTags: [ 'b', 'i', 'em', 'strong', 'a', 'iframe'],
    allowedAttributes: {
      'a': [ 'href' ],
      'iframe': [ 'src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen', 'style']
    },
    allowedIframeHostnames: ['www.youtube.com', 'calendar.google.com']
});

export default clean;